// eslint-disable-next-line no-use-before-define
import React, { useContext } from 'react';
import Avatar from './AvatarDropdown';
import QuickLinks from './QuickLinks';
import NotifLinks from './NotifLinks';
import TasksLinks from './TasksLinks';
import ChecksLink from './ChecksLink';
import Calculator from './Calculator';
import './index.less';
import classNames from 'classnames';
import { Typography } from 'antd';
import APIsInfo from './APIsInfo';
import ModalControllerNV from 'components/ModalControllerNV';
import buildInfo from '../../buildInfo';
import { AuthContext } from 'components/Auth/Auth';
import getEnvValue from 'utils/getEnvValue';
import DF from 'DisplayFramework';

const { Text } = Typography;

const GlobalHeaderRight = (props) => {
  const buildDate =
    new Date(buildInfo.buildDate).getFullYear() +
    '-' +
    Number(new Date(buildInfo.buildDate).getMonth() + 1) +
    '-' +
    new Date(buildInfo.buildDate).getDate() +
    ' __ ' +
    new Date(buildInfo.buildDate).getHours() +
    ' h : ' +
    new Date(buildInfo.buildDate).getUTCMinutes() +
    ' m';
  const { isInspect } = useContext(AuthContext);

  return (
    <DF.Provider pagcode="welcome">
    <div className={'right'}>
      {!props.isExcludedFromLayout ? (
        <>
          <div>
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>
                  {!isInspect&&
                  <Text style={{color:'black',fontSize:14,textDecorationLine:'underline'}} className={'hideOnMobileR'}>
                    @{localStorage.getItem('mgname')} - R
                    {String(
                      JSON.stringify(require('../../../package.json').version)
                    ).replaceAll('"', '') +
                      '_' +
                      buildDate.toString()}{' '}
                    - {getEnvValue('EnvName')}
                  </Text>}
                </a>
              )}
              modal={({ setVisible, visible }) => (
                <APIsInfo
                  onCancel={() => setVisible(false)}
                  visible={visible}
                />
              )}
            />
          </div>

          <div className={classNames('headerItem', 'hideOnMobile')}>
            <Calculator />
          </div>
          <div className={classNames('headerItem', 'hideOnMobile')}>
            <TasksLinks />
          </div>

          <div className={classNames('headerItem', 'hideOnMobile')}>
            <ChecksLink />
          </div>

          <div className={classNames('headerItem', 'hideOnMobile')}>
            <NotifLinks />
          </div>
          <div className={classNames('headerItem', 'hideOnMobile')}>
            <QuickLinks />
          </div>
          <div className={'headerItem'}>
            <Avatar />
          </div>
        </>
      ) : (
        <div className={'headerItem'}>
          <Avatar isExcludedFromLayout={props.isExcludedFromLayout} />
        </div>
      )}
    </div>
    </DF.Provider>
  );
};

export default GlobalHeaderRight;
